import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-center text-size-14 text-weight-500 text-primary-dark" }, [
  /*#__PURE__*/_createTextVNode("\n      今回のお仕事はいかがでしたか？"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("\n      この事業所でまたお仕事してみたい場合"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("\n      他のお仕事にも応募しましょう！\n    ")
], -1)

import RecentOrders from "@/components/molecules/orders/RecentOrders.vue";
import { SlimOrder } from "@/types/order/Order";
import { Order } from "@/types/order/Order";
import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'RecentOrdersWithRecommendText',
  props: {
  currentOrder: {
    type: Object as PropType<Order>,
    required: true
  },
  orders: {
    type: Array as PropType<SlimOrder[]>,
    default: () => []
  },
  applicableOrderCount: {
    type: Number,
    default: 0
  }
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (__props.orders.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createTextVNode(),
        _createVNode(RecentOrders, {
          class: "mt-4 text-left",
          currentOrder: __props.currentOrder,
          orders: __props.orders,
          applicableOrderCount: __props.applicableOrderCount
        }, null, 8, ["currentOrder", "orders", "applicableOrderCount"])
      ]))
    : _createCommentVNode("", true)
}
}

})